import script from "./DocOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./DocOverview.vue?vue&type=script&setup=true&lang=js"

import "./DocOverview.vue?vue&type=style&index=0&id=c4c9675c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4c9675c"]])

export default __exports__